import React from "react";
import { EVENTS } from "../config/siteConfig";

const EventStrip = () => {
  return (
    <section className="py-16 bg-black border-y border-white/5">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-center text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-10">
          Nous accompagnons tous vos événements
        </p>
        <div className="flex flex-wrap justify-center gap-6 md:gap-10">
          {EVENTS.map((evt) => (
            <div
              key={evt.label}
              className="flex flex-col items-center gap-2 group cursor-default"
            >
              <span className="text-3xl group-hover:scale-110 transition-transform duration-300">
                {evt.icon}
              </span>
              <span className="text-xs tracking-widest uppercase text-zinc-500 group-hover:text-zinc-300 transition-colors">
                {evt.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventStrip;
